import {AxiosResponse} from "axios";
import http from "../../common/services/httpService";
import {Api, apiUrls} from "../../helpers/api";
import {WharfsModel} from "../models/wharf";

export class WharfService {
    public static async getAll(): Promise<AxiosResponse<WharfsModel>> {
        return await http.get<WharfsModel>(Api.getUrl(apiUrls.topology.wharfs));
    }
}
